import _extends from "@babel/runtime/helpers/esm/extends";
var _IconLoading, _IconLoading2;
/* eslint-disable no-nested-ternary */
import { Box } from '@mui/material';
import React, { useRef, useState } from 'react';
import Button from "../../../atoms/Button";
import Container from "../../../atoms/Container";
import { IconChecked, IconLoading } from "../../../atoms/Icon";
import Typography from "../../../atoms/Typography";
import DropdownQuantity from "../../../molecules/DropdownQuantity";
import { checkLocaleHkTw } from "../../EStoreBestsellerHome/PopularCard";
import colors from "../../../theme/colors";
import Tabs from "../../EStoreProduct/ProductItem/Tabs";
// eslint-disable-next-line import/no-cycle
import Edition from "./Edition";
import FreeGift from "./FreeGift";
import ModalNotiNotEnough from "./ModalNotiNotEnough";
import Platform from "./Platform";
// eslint-disable-next-line import/no-cycle
import Type from "./Type";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const WrapperContainer = child => {
  return /*#__PURE__*/_jsx(Container, {
    sx: {
      display: "flex",
      flexDirection: "column",
      padding: {
        xs: "0px 32px",
        md: "0px 24px",
        lg: "0px !important"
      }
    },
    children: child
  });
};
export default function Option(props) {
  const {
    tabList,
    title,
    platform,
    itemPlatformSelect,
    itemTypeSelect,
    itemSelectEdition,
    typeOption,
    typeEdition,
    onSelectPlatform,
    onSelectType,
    onSelectEdition,
    buttonPropsAddCart,
    buttonPropsBuyNow,
    maxQuantity,
    quantity,
    onSelectQty,
    labelQty,
    price,
    buttonPropsBuyNowDigital,
    isSelectTypeDigital,
    padding = 0,
    freeGift,
    loadingBtnAddCart = false,
    stateAdded = false,
    titleAdded = "Added",
    maxItemOrder = 1,
    helperTextNotEnough = "",
    helperTextQuantityLeft = "",
    contentModal,
    isSoldOut,
    loadingBtnBuyNow = false,
    salePrice = "",
    titleSale = "",
    onClickAddToCart,
    onClickBuyNow,
    locale,
    titleTaxForTC
  } = props;
  const refWrapper = useRef();
  const [openModalNotiNotEnough, setOpenModalNotiNotEnough] = useState(false);
  const [isLoadPage, setIsLoadPage] = useState(false);

  // useEffect(() => {
  //     if (typeof window !== "undefined") {
  //         const wrapper = refWrapper.current;
  //         if (wrapper) {
  //             window.addEventListener("resize", () => {
  //                 wrapper?.scrollTo({ left: 0, behavior: "smooth" })
  //             });
  //         }
  //     };
  //     return () => {
  //         window.removeEventListener("resize", () => { });
  //     }
  // }, []);

  const handelReturnCheckDisable = () => {
    if (isSoldOut) {
      return true;
    }
    let result = true;
    if (!typeEdition?.editionList?.length) {
      return true;
    }
    if (!typeOption?.typeList?.length && !typeEdition?.editionList?.length) {
      if (!itemPlatformSelect?.id) {
        result = true;
        return true;
      }
      return false;
    }
    if (!!typeOption?.typeList?.length && !!typeEdition?.editionList?.length) {
      if (itemPlatformSelect?.id && !!itemTypeSelect?.id && !!itemSelectEdition?.id) {
        return false;
      }
      return true;
    }
    if (!typeOption?.typeList?.length) {
      if (itemPlatformSelect?.id && !!itemSelectEdition?.id) {
        return false;
      }
      return true;
    }
    return result;
  };
  const handleSelectQty = q => {
    onSelectQty?.(q);
  };
  const handleClickAddToCart = () => {
    if ((quantity || 1) > maxItemOrder) {
      setOpenModalNotiNotEnough(true);
      return;
    }
    onClickAddToCart?.(error => {
      if (error?.status === true) {
        setOpenModalNotiNotEnough(true);
        setIsLoadPage(true);
      }
    });
  };
  const handleClickBuyNow = () => {
    if (loadingBtnBuyNow) {
      return;
    }
    if ((quantity || 1) > maxItemOrder) {
      setOpenModalNotiNotEnough(true);
      return;
    }
    onClickBuyNow?.(error => {
      if (error?.status === true) {
        setOpenModalNotiNotEnough(true);
        setIsLoadPage(true);
      }
    });
  };
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      marginLeft: {
        xs: "0px",
        lg: "56px"
      },
      marginTop: {
        xs: "40px",
        lg: "0px"
      },
      width: "100%"
    },
    children: [WrapperContainer( /*#__PURE__*/_jsxs(React.Fragment, {
      children: [!!tabList?.length && /*#__PURE__*/_jsx(Box, {
        sx: {
          width: "100%",
          marginBottom: "4px"
        },
        children: /*#__PURE__*/_jsx(Tabs, {
          tabList: tabList || [],
          locale: locale
        })
      }), /*#__PURE__*/_jsx(Typography, {
        variant: "h4",
        sx: {
          display: "flex"
        },
        children: title
      })]
    })), /*#__PURE__*/_jsxs(Box, {
      sx: {
        display: "flex",
        flexDirection: "column",
        paddingTop: {
          xs: "48px",
          lg: "64px"
        }
      },
      children: [WrapperContainer( /*#__PURE__*/_jsx(Typography, {
        color: colors.neutral.neutral2,
        variant: "p5",
        sx: {
          marginBottom: "14px"
        },
        children: platform?.title
      })), !!platform?.platformList?.length && /*#__PURE__*/_jsxs(Box, {
        sx: {
          display: "flex",
          flexWrap: {
            xs: "nowrap",
            lg: "wrap"
          },
          gap: "14px",
          overflow: "auto",
          overflowX: {
            xs: "scroll",
            ld: "auto"
          },
          scrollSnapType: "x mandatory",
          WebkitOverflowScrolling: "touch",
          overscrollBehaviorX: "contain",
          "&::-webkit-scrollbar": {
            display: "none"
          }
        },
        ref: refWrapper,
        children: [platform?.platformList.map((item, index) => {
          return /*#__PURE__*/_jsx(Box, {
            sx: {
              display: "inline-block",
              scrollSnapAlign: "start",
              opacity: isSoldOut || item?.isDisable ? "0.4" : "1",
              pointerEvents: isSoldOut || item?.isDisable ? "none" : "auto"
            },
            children: /*#__PURE__*/_jsx(Box, {
              sx: {
                transform: {
                  xs: `translateX(${padding + 16}px)`,
                  md: `translateX(${padding}px)`
                }
              },
              children: /*#__PURE__*/_jsx(Platform, {
                isSelect: itemPlatformSelect?.id === item?.id,
                titleIcon: item?.value,
                onClick: () => loadingBtnAddCart || loadingBtnBuyNow ? {} : onSelectPlatform?.(item)
              })
            })
          }, index);
        }), /*#__PURE__*/_jsx(Box, {
          sx: {
            display: "inline-block",
            scrollSnapAlign: "start"
          },
          children: /*#__PURE__*/_jsx(Box, {
            sx: {
              transform: {
                xs: `translateX(${padding + 16}px)`,
                md: `translateX(${padding}px)`
              }
            },
            children: /*#__PURE__*/_jsx(Box, {
              sx: {
                display: "inline-block",
                width: `${padding}px`,
                height: "100%",
                background: "red"
              }
            })
          })
        })]
      })]
    }), !!typeOption?.typeList?.length && /*#__PURE__*/_jsx(Box, {
      sx: {
        paddingTop: "44px"
      },
      children: /*#__PURE__*/_jsx(Type, _extends({}, typeOption, {
        padding: padding,
        isDisable: isSoldOut || !itemPlatformSelect?.id,
        itemSelectType: itemTypeSelect,
        onSelectType: value => loadingBtnAddCart || loadingBtnBuyNow ? {} : onSelectType?.(value)
      }))
    }), !!typeEdition?.editionList?.length && /*#__PURE__*/_jsx(Box, {
      sx: {
        paddingTop: "44px"
      },
      children: /*#__PURE__*/_jsx(Edition, _extends({}, typeEdition, {
        padding: padding,
        isDisable: isSoldOut || !typeOption?.typeList?.length ? !itemPlatformSelect?.id : !itemPlatformSelect?.id || !itemTypeSelect?.id,
        itemSelectEdition: itemSelectEdition,
        onSelectEdition: value => loadingBtnAddCart || loadingBtnBuyNow ? {} : onSelectEdition?.(value)
      }))
    }), WrapperContainer( /*#__PURE__*/_jsx(FreeGift, _extends({}, freeGift))), WrapperContainer( /*#__PURE__*/_jsxs(React.Fragment, {
      children: [/*#__PURE__*/_jsx(Box, {
        sx: {
          width: "100%",
          display: "flex",
          flexDirection: "column"
        },
        children: !!typeEdition?.editionList?.length && /*#__PURE__*/_jsxs(React.Fragment, {
          children: [/*#__PURE__*/_jsxs(Box, {
            sx: {
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              paddingTop: "44px"
            },
            children: [!isSelectTypeDigital && /*#__PURE__*/_jsx(Box, {
              sx: {
                opacity: handelReturnCheckDisable() ? "0.4" : "1",
                pointerEvents: loadingBtnAddCart || loadingBtnBuyNow || handelReturnCheckDisable() ? "none" : "auto"
              },
              children: /*#__PURE__*/_jsx(DropdownQuantity, {
                maxQuantity: maxQuantity || 5,
                currentQuantity: quantity ?? 1,
                label: labelQty,
                onSetQuantity: q => handleSelectQty(q)
              })
            }), /*#__PURE__*/_jsxs(Box, {
              sx: {
                display: "flex",
                flexDirection: "column",
                alignItems: isSelectTypeDigital || itemTypeSelect?.value === "digital" ? "flex-start" : "flex-end"
              },
              children: [/*#__PURE__*/_jsx(Typography, {
                variant: "h6",
                color: colors.primary.bandaiNamcoBlack,
                children: price
              }), !!salePrice && /*#__PURE__*/_jsxs(Box, {
                sx: {
                  display: "flex"
                },
                children: [/*#__PURE__*/_jsx(Typography, {
                  color: "#737373",
                  sx: {
                    textDecoration: "line-through",
                    fontSize: {
                      xs: "10px",
                      md: "16px"
                    },
                    lineHeight: {
                      xs: "12px",
                      md: "22px"
                    },
                    fontWeight: "600"
                  },
                  children: salePrice
                }), titleSale && /*#__PURE__*/_jsx(Typography, {
                  color: "#DF4662",
                  sx: {
                    textTransform: "lowercase",
                    marginLeft: {
                      xs: "4px",
                      md: "8px"
                    },
                    fontSize: {
                      xs: "10px",
                      md: "16px"
                    },
                    lineHeight: {
                      xs: "12px",
                      md: "22px"
                    },
                    fontWeight: "600"
                  },
                  children: titleSale
                })]
              }), checkLocaleHkTw(locale) && /*#__PURE__*/_jsx(Typography, {
                variant: "p9",
                color: "#1E1E1E",
                sx: {
                  marginTop: "4px",
                  fontSize: {
                    md: "12px",
                    xs: "10px"
                  }
                },
                children: titleTaxForTC
              })]
            })]
          }), (quantity || 1) > maxItemOrder && maxItemOrder !== 0 && !isSelectTypeDigital && /*#__PURE__*/_jsx(Typography, {
            variant: "p9",
            sx: {
              color: colors.primary.bandaiNamcoRed,
              fontSize: "12px",
              lineHeight: "16px",
              marginTop: {
                xs: "4px",
                md: "8px"
              }
            },
            children: checkLocaleHkTw(`${locale}`.toLowerCase()) ? `${helperTextNotEnough}${maxItemOrder}${helperTextQuantityLeft}` : `${helperTextNotEnough} ${maxItemOrder} ${helperTextQuantityLeft}`
          })]
        })
      }), /*#__PURE__*/_jsx(Box, {
        sx: {
          width: "100%",
          display: "flex",
          flexDirection: "column",
          paddingTop: "48px"
        },
        children: !isSelectTypeDigital ? /*#__PURE__*/_jsxs(Box, {
          sx: {
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            "& button": {
              width: {
                xs: "calc(50% - 8px)",
                lg: "calc(50% - 12px)"
              }
            }
          },
          children: [/*#__PURE__*/_jsx(Button, {
            variant: buttonPropsAddCart?.variant,
            label: stateAdded ? /*#__PURE__*/_jsxs(Box, {
              sx: {
                display: "flex",
                alignItems: "center",
                "& svg": {
                  marginBottom: "1px",
                  marginRight: "6px",
                  "& path": {
                    fill: "transparent !important"
                  }
                }
              },
              children: [/*#__PURE__*/_jsx(IconChecked, {
                htmlColor: colors.primary.bandaiNamcoBlack
              }), " ", titleAdded]
            }) : loadingBtnAddCart ? _IconLoading || (_IconLoading = /*#__PURE__*/_jsx(IconLoading, {})) : buttonPropsAddCart?.label,
            disabled: handelReturnCheckDisable(),
            onClick: () => {
              handleClickAddToCart();
            }
          }), /*#__PURE__*/_jsx(Button, _extends({}, buttonPropsBuyNow, {
            variant: loadingBtnBuyNow ? "secondaryBlack" : handelReturnCheckDisable() ? "primary" : buttonPropsBuyNow?.variant,
            disabled: handelReturnCheckDisable(),
            onClick: () => {
              handleClickBuyNow();
            },
            label: loadingBtnBuyNow ? _IconLoading2 || (_IconLoading2 = /*#__PURE__*/_jsx(IconLoading, {})) : buttonPropsBuyNow?.label
          }))]
        }) : /*#__PURE__*/_jsx(Button, _extends({}, buttonPropsBuyNowDigital, {
          variant: handelReturnCheckDisable() ? "primary" : buttonPropsBuyNow?.variant,
          disabled: handelReturnCheckDisable(),
          onClick: e => {
            if ((quantity || 1) > maxItemOrder) {
              setOpenModalNotiNotEnough(true);
              return;
            }
            buttonPropsBuyNowDigital?.onClick?.(e);
          }
        }))
      })]
    })), /*#__PURE__*/_jsx(ModalNotiNotEnough, _extends({}, contentModal, {
      isLoadPage: isLoadPage,
      total: maxItemOrder,
      open: openModalNotiNotEnough,
      onClose: () => setOpenModalNotiNotEnough(false)
    }))]
  });
}